import React from "react";

type Props = {
  label: string;
  href: string;
  onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const MenuItem = (props: Props) => {
  return (
    <a
      href={`/#${props.href}`}
      onClick={props.onClick}
      className="block text-5xl font-semibold text-violet-400 transition-colors hover:text-violet-50 md:text-7xl"
      style={{ opacity: "1", transform: "none" }}
    >
      {props.label}
    </a>
  );
};

export default MenuItem;
